<template>
  <div class="process-content" v-show="show" id="process-dialog">
    <div class="procss-container">
      <span class="percent">加载中。。。{{ percentage }}%</span>
      <div class="cont" ref="cont">
        <div class="anim" ref="anim" :style="{ width: width + 'px' }"></div>
      </div>
      <div></div>
      <p class="message-text">{{ message }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'process-com',
  data () {
    return {
      timer: null,
      percentage: 0,
      width: 0,
      show: false
    }
  },
  beforeDestroy () {
    if (this.timer) {
      clearInterval(this.timer)
    }
  },
  computed: {
    message () {
      if (this.percentage < 30) {
        return '手机号校验中'
      } else if (this.percentage < 60) {
        return '手机号校验成功，服务提交中'
      } else {
        return '服务提交中,马上就好啦，请不要关闭页面哟~'
      }
    }
  },
  methods: {
    setPercentage (num) {
      if (this.timer) {
        clearInterval(this.timer)
        this.timer = null
      }
      this.percentage = num
      // 设置宽度
      const parentWidth = this.$refs.anim.parentNode.clientWidth
      const prcessWidth = (num / 100) * parentWidth
      this.$refs.anim.style.width = prcessWidth + 'px'
      if (this.percentage < 99) {
        this.setProcess(prcessWidth)
      }
    },
    setProcess () {
      if (this.timer) {
        clearInterval(this.timer)
        this.timer = null
      }
      const parentWidth = this.$refs.anim.parentNode.clientWidth

      this.timer = setInterval(() => {
        if (this.percentage < 100) {
          if (this.percentage >= 90) {
            clearInterval(this.timer)

            this.timer = setInterval(() => {
              let percentage = this.percentage
              percentage = Number(percentage + Math.random().toFixed(2))
              if (percentage + Number(Math.random().toFixed(2)) > 99) {
                this.percentage = 99
              } else {
                this.percentage = percentage
              }
              this.width = (this.percentage / 100) * parentWidth

              if (this.percentage >= 99) {
                this.width = parentWidth
                clearInterval(this.timer)
              }
            }, 100)
          } else {
            this.percentage++
            this.width = (this.percentage / 100) * parentWidth
          }
        }
      }, 100)
    },
    process () {
      this.setProcess(30, 100)
    },
    init () {
      this.show = true
      this.$nextTick(() => {
        this.setProcess(0)
      })
    },
    close () {
      this.show = false
      this.width = 0
      this.percentage = 0
      if (this.timer) {
        clearInterval(this.timer)
        this.timer = null
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/css/_handle.scss";
.process-content {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.1); /* 半透明黑色背景 */
  z-index: 1001;
  display: flex;
  align-items: center;
  justify-content: center;

  .procss-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    z-index: 1002;
    position: relative;
    width: 328px;
    background-color: #ffffff;
    border-radius: 24px;
    z-index: 999;
    @include field_background_color1("field_background_color1");
    .order-dialog-text {
      // width:280px;
      height: 26px;
      text-align: center;
      font-size: 18px;
      font-weight: 500;
      margin-top: 53px;
      // margin-left:24px;
      @include title_color("title_color");
    }
    .order-dialog-bar {
      width: 170px;
      height: 5px;
      margin: 33px auto;
    }
  }

  .percent {
    color: #f04e48;
    font-size: 18px;
    margin: 20px 0;
  }

  .message-text {
    @include header_color("header_color");
    font-size: 14px;
    margin: 20px 0;
  }
}

.anim {
  position: absolute;
  top: 0;
  left: 0px;
  height: 8px;
  background-size: 30px 30px;
  /*添加条纹背景*/
  background-image: linear-gradient(
    60deg,
    #f9c288 10px,
    #f9c288 8px,
    #ff9022 9px,
    #ff9022 20px,
    #f9c288 21px,
    #f9c288 36px,
    #ff9022 37px
  );
  transition: 0.3s all;
  border-radius: 50px;
}

.cont {
  width: 300px;
  height: 8px;
  position: relative;
  background-color: #f2f2f2;
  border-radius: 20px;
  overflow: hidden;
}

@keyframes load {
  0% {
    width: 0;
  }

  100% {
    width: 100%;
  }
}
</style>
